import { useEffect, useState } from "react";
import apiGet from "../../api/apiGet";
import CaretUp from "./CaretUp";

export default function PostFilters({ filters = {}, setFilters = () => {} }) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const [categories, setCategories] = useState({});

  const getCategories = async () => {
    try {
      setError(null);
      setLoading(true);

      let query = {
        per_page: 99,
        exclude: [1],
      };

      const response = await apiGet({
        url: `${rafa_react_components.home_url}/wp-json/wp/v2/categories`,
        debug: true,
        query,
      });

      const heirarchialCategories = { topLevel: [] };

      response.data.forEach((category) => {
        if (category.parent === 0) {
          heirarchialCategories.topLevel.push(category);
        } else {
          if (heirarchialCategories[category.parent] === undefined) {
            heirarchialCategories[category.parent] = [];
          }
          heirarchialCategories[category.parent].push(category);
        }
      });

      // Sort the top level categories
      heirarchialCategories.topLevel.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      setCategories(heirarchialCategories);

      setLoading(false);
    } catch (err) {
      console.error(err);
      setError(err);
    }
  };

  const setCategoriesFilter = (id) => {
    let newFilters = {};

    if (!filters.categories) {
      newFilters = { ...filters, categories: [id] };
    } else {
      if (filters.categories.includes(id)) {
        newFilters = {
          ...filters,
          categories: filters.categories.filter((cat) => cat !== id),
        };
        if (newFilters.categories.length === 0) delete newFilters.categories;
      } else {
        newFilters = { ...filters, categories: [...filters.categories, id] };
      }
    }

    setFilters(newFilters);
  };

  useEffect(() => {
    getCategories();
  }, []);

  return error ? (
    <p>{error.message}</p>
  ) : loading ? (
    <p>Loading...</p>
  ) : (
    <div className="post-filters max-h-screen h-full overflow-y-auto !pr-2 rafa-scrollbar">
      <header className="flex flex-row justify-between !pb-2 border-b border-gray-200">
        <h3 className="font-semibold uppercase">Filter By</h3>
        {Object.keys(filters).length > 0 && (
          <button
            className="font-normal cursor-pointer uppercase !text-[10px]"
            type="button"
            onClick={() => setFilters({})}
          >
            Clear
          </button>
        )}
      </header>

      {categories.topLevel.map((category) => {
        return categories[category.id] && categories[category.id].length > 0 ? (
          <div
            class="collapsible category-collapsible border-b border-gray-200"
            key={category.id}
          >
            <input
              id={`collapsible-category+${category.id}`}
              class="hidden"
              type="checkbox"
            />
            <label
              for={`collapsible-category+${category.id}`}
              className="!cursor-pointer font-semibold text-black flex flex-row items-center justify-between !py-2"
            >
              {category.name}
              <CaretUp className="w-4" />
            </label>

            <ul className="collapse flex flex-col">
              {categories[category.id].map((subCategory) => {
                return (
                  <li
                    className="!p-2 border border-gray-200 !-mt-[1px]"
                    key={subCategory.id}
                  >
                    <label
                      title={`${subCategory.name} - ${subCategory.count} ${subCategory.count === 1 ? "post" : "posts"}`}
                      className="!cursor-pointer flex flex-row items-center"
                      onClick={() => setCategoriesFilter(subCategory.id)}
                    >
                      <div
                        className={`border border-gray-200 w-6 h-6 !mr-2 shrink-0 grow-0`}
                      >
                        {filters.categories &&
                          filters.categories.includes(subCategory.id) && (
                            <div className="w-full h-full bg-rafa-red !border-2 border-white"></div>
                          )}
                      </div>
                      <div
                        className={`whitespace-nowrap overflow-hidden text-ellipsis uppercase ${filters.categories && filters.categories.includes(subCategory.id) ? "text-rafa-red" : ""}`}
                      >
                        {subCategory.name}
                      </div>
                      <div
                        className={`!ml-auto !px-1 shrink-0 grow-0 flex items-center justify-center text-white text-[10px] rounded ${filters.categories && filters.categories.includes(subCategory.id) ? "bg-rafa-red" : "bg-gray-600"}`}
                      >
                        {subCategory.count}
                      </div>
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
        ) : (
          <></>
        );
      })}
    </div>
  );
}
